// FIXME falscher Text in englisch bei den Ladestationen linke Spaltenüberschrift
// FIXME Preise für Holzmasten, ggf. NaN einstellen, hauptsache etwas anderes als bei den Metallmasten


// Dauer-TODO: Wenn SX-Nummer hinzugefügt wird, sicherstellen dass diese von getAllSX() erfasst ist

var OLIVIO = typeof OLIVIO !== 'undefined' ? OLIVIO : require('./design/olivio_lib.js'); // nur nötig für das module, wo OLIVIO ja nicht global definiert ist

(function() {
  var data = {
    locales: {
      'at': {
        language: 'de',
        email: 'info@selux.at',
        prices: "local"
      },
      'au': {
        language: 'en',
        email: 'info@selux.com.au',
        prices: "local"
      },
      'be': {
        language: 'en',
        email: 'quotes@selux.co.uk',
        prices: "local"
      },
      'de': {
        language: 'de',
        email: 'info@selux.de',
        prices: "local"
      },
      'fr': {
        language: 'fr',
        email: 'info@selux.fr',
        prices: "local"
      },
      'nl': {
        language: 'en',
        email: 'info@selux.nl',
        prices: "local"
      },
      'it': {
        language: 'en',
        email: 'info@selux.it',
        prices: "local"
      },
      'se': {
        language: 'en',
        email: 'info@selux.se',
        prices: "foreign"
      },
      'uk': {
        language: 'en',
        email: 'quotes@selux.co.uk',
        prices: "local"
      },
      'en': {
        language: 'en',
        email: 'quotes@selux.co.uk',
        prices: "local"
      },
      'us': {
        language: 'en',
        email: 'info@selux.us',
        prices: "local"
      }
    },
    productOptions: [
      {
        id: OLIVIO.PRODUCT_SISTEMA,
        filterid: OLIVIO.PRODUCT_SISTEMA,
        name: 'Sistema'
      },
      {
        id: OLIVIO.PRODUCT_FLORACION,
        filterid: OLIVIO.PRODUCT_FLORACION,
        name: 'Floracion'
      },
      {
        id: OLIVIO.PRODUCT_CANDELABRA,
        filterid: OLIVIO.PRODUCT_CANDELABRA,
        name: 'Candelabra'
      }
    ],
    lumOptions: [
      {
        id: OLIVIO.LUM_PICCOLO,
        filterid: OLIVIO.LUM_PICCOLO,
        name: 'Piccolo Ø 106',
        info: 'a) 166mm, b) 178mm, c)  Ø 106mm',
        image: 'images/design_lumtype0.svg',
        checkoutimage: 'images/checkout_lumtype_medio.svg',
        disabled: false
      },
      {
        id: OLIVIO.LUM_MEDIO,
        filterid: OLIVIO.LUM_MEDIO,
        name: 'Medio Ø 163',
        info: 'a) 260mm, b) 260mm, c)  Ø 163mm',
        image: 'images/design_lumtype_medio.svg',
        checkoutimage: 'images/checkout_lumtype_medio.svg',
        disabled: false
      },
      {
        id: OLIVIO.LUM_GRANDE,
        filterid: OLIVIO.LUM_GRANDE,
        name: 'Grande Ø 205',
        info: 'a) 317mm, b) 324mm, c)  Ø 205mm',
        image: 'images/design_lumtype_grande.svg',
        checkoutimage: 'images/checkout_lumtype_grande.svg',
        disabled: false
      }
    ],
    goboHead: { /* Eintrag wird jetzt für checkout genutzt, weil Gobo-Köpfe aus zwei Teilen bestehen, hier der Kopf, unter gobo: unten das Objektiv. */
      id: 'gobo', // see DetailsCtrl
      //name: 'Grande Gobo',
      //info: '!!!a) 317mm, b) 324mm, c)  Ø 205mm',
      //image: 'images/design_lumtype_grande-gobo.svg',
      //checkoutimage: 'images/checkout_lumtype_grande.svg',
      sxno: 'SX 960 90-9'
    },
    //  ACHTUNG: Wegen Umstrukturierung der Mastoptionen, gibt es keinen masttype mehr. Stattdessen ist die id jetzt die product id. -> nur ein Masttyp je Produkt
    mastOptions: [
      {
        id: OLIVIO.PRODUCT_SISTEMA,
        filterid: 'sistema_international',
        productid: OLIVIO.PRODUCT_SISTEMA,

        name: 'Mast Sistema',
        image: '',
        imagewhite: '',
        checkoutimage: '',
        mastSizesmm: [12000, 11000, 10000, 9000, 8000, 7000, 6000],
        mastDiametermm: ['108/230', '108/220', '89/201', '89/190', '89/179', '89/168', '89/157'],
        mastSX: ['160 12-9', '160 11-9', '160 10-9', '160 09-9', '160 08-9', '160 07-9', '160 06-9'],
      },
      {
        id: OLIVIO.PRODUCT_FLORACION,
        filterid: 'floracion_international',
        productid: OLIVIO.PRODUCT_FLORACION,
        name: 'Mast Floration',
        image: '',
        imagewhite: '',
        checkoutimage: '',
        mastSizesmm: [12000, 11000, 10000, 9000, 8000, 7000, 6000, 5000],
        mastDiametermm: ['219', '219', '219', '219', '219', '219', '219', '219'],
        mastSX: ['161 12-9', '161 11-9', '161 10-9', '161 09-9', '161 08-9', '161 07-9', '161 06-9', '161 05-9'],
      },
      {
        id: OLIVIO.PRODUCT_CANDELABRA,
        filterid: 'candelabra_international',
        productid: OLIVIO.PRODUCT_CANDELABRA,
        mastSizesmm: [4500, 3500],
        mastDiametermm: ['---', '---'],
        mastSX: ['197 40-9', '197 30-9'],
        mastSXCandelabra: [ // mast sx dependends on lumcount!
          ['197 40-9', '197 30-9'],
          ['197 41-9', '197 31-9'],
          ['197 42-9', '197 32-9']
        ],
        name: 'Mast Candelabra',
        image: '',
        imagewhite: '',
        checkoutimage: ''
      }
    ],
    bracketOptions: [
      {
        id: OLIVIO.BRACKET_SISTEMA1,
        filterid: 'sistema1_international',
        attachablelums: [OLIVIO.LUM_MEDIO, OLIVIO.LUM_GRANDE],
        name: 'Sistema 1',
        info: 'a) 629mm, b: 275mm',
        image: 'images/design_bracket_sistema1.svg',
        imagewhite: 'images/design_bracket_sistema1_white.svg',
        checkoutimage: 'images/checkout_bracket_sistema1.svg',
        manual: 'CHECKOUT.MANUAL_SISTEMA1', //pdf
        drilloffset: 536,
        disabled: false,
        sxno: 'SX 97-514-9',
      },
      {
        id: OLIVIO.BRACKET_SISTEMA2,
        filterid: 'sistema2_international',
        attachablelums: [OLIVIO.LUM_MEDIO, OLIVIO.LUM_GRANDE],
        name: 'Sistema 2',
        info: 'a) 507mm, b) 214mm',
        image: 'images/design_bracket_sistema2.svg',
        imagewhite: 'images/design_bracket_sistema2_white.svg',
        checkoutimage: 'images/checkout_bracket_sistema2.svg',
        manual: 'CHECKOUT.MANUAL_SISTEMA2', //pdf
        drilloffset: 480,
        disabled: false,
        sxno: 'SX 97-515-9',
      },
      {
        id: OLIVIO.BRACKET_SISTEMA3,
        filterid: 'sistema3_international',
        attachablelums: [OLIVIO.LUM_PICCOLO, OLIVIO.LUM_MEDIO, OLIVIO.LUM_GRANDE],
        name: 'Sistema 3',
        info: 'a) 115mm, b) 80mm',
        image: 'images/design_bracket_sistema3.svg',
        imagewhite: 'images/design_bracket_sistema3_white.svg',
        checkoutimage: 'images/checkout_bracket_sistema3.svg',
        manual: 'CHECKOUT.MANUAL_SISTEMA3', //pdf
        drilloffset: 42.5,
        disabled: false,
        sxno: 'SX 97-551-9',
        sxnoPiccolo: 'SX 97-552-9',
      }
    ],
    assemblyOptions: [
      {
        id: 'led',
        filterid: 'led',
        name: 'ASSEMBLY.LED',
        description: 'ASSEMBLY.LED_DESCRIPTION',
        disabled: false
      },
      {
        id: 'hit',
        filterid: 'hit',
        name: 'ASSEMBLY.HIT',
        description: 'ASSEMBLY.HIT_DESCRIPTION',
        disabled: false
      },
      {
        id: 'cpo',
        filterid: 'cpo',
        name: 'ASSEMBLY.CPO',
        description: 'ASSEMBLY.CPO_DESCRIPTION',
        disabled: false
      }
    ],
    distributionOptions: [
      {
        id: 'typ2',
        filterid: 'typ2',
        name: 'DISTRIBUTION.TYP2', //Flood
        image: 'images/distribution_typ2.svg',
        disabled: false
      },
      {
        id: 'asymetric',
        filterid: 'asymetric',
        name: 'DISTRIBUTION.ASYMETRIC', //asymetrisch
        image: 'images/distribution_asymetric.svg',
        disabled: false
      },
      {
        id: 'spot',
        filterid: 'spot',
        name: 'DISTRIBUTION.SPOT', //Spot
        image: 'images/distribution_spot.svg',
        disabled: false
      },
      {
        id: 'typ5',
        filterid: 'typ5',
        name: 'DISTRIBUTION.TYP5', //Flood
        image: 'images/distribution_typ5.svg',
        disabled: false
      },
      {
        id: 'medium',
        filterid: 'medium',
        name: 'DISTRIBUTION.MEDIUM', //Medium
        image: 'images/distribution_medium.svg',
        disabled: false
      },
      {
        id: 'flood',
        filterid: 'flood',
        name: 'DISTRIBUTION.FLOOD', //Flood
        image: 'images/distribution_flood.svg',
        disabled: false
      }
    ],
    goboOptions: [
      {
        id: 'extrawide',
        filterid: 'extrawide',
        name: 'GOBO.EXTRAWIDE',
        image: 'images/gobo_Extraweit.svg',
        sxno: 'SX 97-603-0',
        disabled: false
      },
      {
        id: 'wide',
        filterid: 'wide',
        name: 'GOBO.WIDE',
        image: 'images/gobo_Weitwinkel.svg',
        sxno: 'SX 97-602-0',
        disabled: false
      },
      {
        id: 'standard',
        filterid: 'standard',
        name: 'GOBO.STANDARD',
        image: 'images/gobo_Standard.svg',
        sxno: 'SX 97-600-0',
        disabled: false
      },
      {
        id: 'tele',
        filterid: 'tele',
        name: 'GOBO.TELE',
        image: 'images/gobo_Tele.svg',
        sxno: 'SX 97-601-0',
        disabled: false
      },
    ],
    colorOptions: [
      {
        id: '2700K',
        filterid: '2700K',
        name: 'COLOR.COL2700K', //2700K
        description: 'COLOR.COL2700K_DESCRIPTION',
        disabled: false
      },
      {
        id: '3000K',
        filterid: '3000K',
        name: 'COLOR.COL3000K', //3000K
        description: 'COLOR.COL3000K_DESCRIPTION',
        disabled: false
      },
      {
        id: '4000K',
        filterid: '4000K',
        name: 'COLOR.COL4000K', //4000K
        description: 'COLOR.COL4000K_DESCRIPTION',
        disabled: false
      },
      {
        id: '4200K',
        filterid: '4200K',
        name: 'COLOR.COL4200K', //4200K
        description: 'COLOR.COL4200K_DESCRIPTION',
        disabled: false
      },
      {
        id: '5300K',
        filterid: '5300K',
        name: 'COLOR.COL5300K', //5300K
        description: 'COLOR.COL5300K_DESCRIPTION',
        disabled: false
      },
      {
        id: 'rgbw',
        filterid: 'rgbw',
        name: 'COLOR.RGBW', //RGBW
        description: 'COLOR.RGBW_DESCRIPTION',
        disabled: false
      },
      {
        id: 'monochrome',
        filterid: 'monochrome',
        name: 'COLOR.MONOCHROME', //monochrome
        description: 'COLOR.MONOCHROME_DESCRIPTION',
        disabled: false
      },
      {
        id: '6500K',
        filterid: '6500K',
        name: '6500K',
        description: '6500K',
        disabled: false
      }
    ],
    powerOptions: [
      //int: ['20w', '24w', '26w', '29w', '35w', '37w', '39w', '41w', '45w', '53w', '60w', '70w', '100w', '150w']
      {
        id: '20w',
        filterid: '20w',
        name: '20 W',
        description: '',
        disabled: false
      },
      {
        id: '24w',
        filterid: '24w',
        name: '24 W',
        description: '',
        disabled: false
      },
      {
        id: '26w',
        filterid: '26w',
        name: '26 W',
        description: '',
        disabled: false
      },
      {
        id: '29w',
        filterid: '29w',
        name: '29 W',
        description: '',
        disabled: false
      },
      {
        id: '35w',
        filterid: '35w',
        name: '35 W',
        description: '',
        disabled: false
      },
      {
        id: '37w',
        filterid: '37w',
        name: '37 W',
        description: '',
        disabled: false
      },
      {
        id: '39w',
        filterid: '39w',
        name: '39 W',
        description: '',
        disabled: false
      },
      {
        id: '41w',
        filterid: '41w',
        name: '41 W',
        description: '',
        disabled: false
      },
      {
        id: '45w',
        filterid: '45w',
        name: '45 W',
        description: '',
        disabled: false
      },
      {
        id: '49w',
        filterid: '49w',
        name: '49 W',
        description: '',
        disabled: false
      },
      {
        id: '53w',
        filterid: '53w',
        name: '53 W',
        description: '',
        disabled: false
      },
      {
        id: '60w',
        filterid: '60w',
        name: '60 W',
        description: '',
        disabled: false
      },
      {
        id: '70w',
        filterid: '70w',
        name: '70 W',
        description: '',
        disabled: false
      },
      {
        id: '100w',
        filterid: '100w',
        name: '100 W',
        description: '',
        disabled: false
      },
      {
        id: '150w',
        filterid: '150w',
        name: '150 W',
        description: '',
        disabled: false
      },

      // led   FIXME beim Laden von Konfigurationen mit led umstellen aufgrund Kopfgröße und distribution
      { id: 'ga39w', name: '39 W', description: '3600 lm', disabled: false },
      { id: 'gf41w', name: '41 W', description: '4500 lm', disabled: false },
      { id: 'gm39w', name: '39 W', description: '4500 lm', disabled: false },
      { id: 'gs37w', name: '37 W', description: '4500 lm', disabled: false },
      { id: 'ma28w', name: '28 W', description: '2400 lm', disabled: false },
      { id: 'mf28w', name: '28 W', description: '3000 lm', disabled: false },
      { id: 'mm28w', name: '28 W', description: '3000 lm', disabled: false },
      { id: 'ms26w', name: '26 W', description: '3000 lm', disabled: false },
      { id: 'pa21w', name: '21 W', description: '1500 lm', disabled: false },
      { id: 'pf21w', name: '21 W', description: '1800 lm', disabled: false },
      { id: 'pm21w', name: '21 W', description: '1800 lm', disabled: false },
      { id: 'ps21w', name: '21 W', description: '1800 lm', disabled: false },

      // led rgbw 20190222
      { id: 'rgbw24w', name: '24 W', description: ' 900 lm', disabled: false },
      { id: 'rgbw35w', name: '35 W', description: '1800 lm', disabled: false },
      { id: 'rgbw45w', name: '45 W', description: '2100 lm', disabled: false },

      // led 27k 202201
      {id: 'g27s', description: '4500 lm', name: '41 W', disabled: false},
      {id: 'g27m', description: '4500 lm', name: '43 W', disabled: false},
      {id: 'g27f', description: '4500 lm', name: '45 W', disabled: false},
      {id: 'g27a', description: '3600 lm', name: '43 W', disabled: false},
      {id: 'm27s', description: '3000 lm', name: '29 W', disabled: false},
      {id: 'm27m', description: '3000 lm', name: '29 W', disabled: false},
      {id: 'm27f', description: '3000 lm', name: '30 W', disabled: false},
      {id: 'm27a', description: '2400 lm', name: '30 W', disabled: false},
      {id: 'p27s', description: '1500 lm', name: '16 W', disabled: false},
      {id: 'p27m', description: '1500 lm', name: '16 W', disabled: false},
      {id: 'p27f', description: '1500 lm', name: '18 W', disabled: false},
      {id: 'p27a', description: '1500 lm', name: '19 W', disabled: false}

    ],
    metalColorSelectOptions: [
      {
        id: 'seluxGraphite',
        name: 'COLORS.SELUXGRAPHITE',
        code: '',
        color: '#7b8282',
        colorOutline: '#000000'
      },
      {
        id: 'ral9005',
        name: 'COLORS.RAL9005',
        code: 'RAL 9005',
        color: '#000000',
        colorOutline: '#ffffff'
      },
      {
        id: 'ral7016',
        name: 'COLORS.RAL7016',
        code: 'RAL 7016',
        color: '#083238',
        colorOutline: '#ffffff'
      },
      {
        id: 'ral7024',
        name: 'COLORS.RAL7024',
        code: 'RAL 7024',
        color: '#244551',
        colorOutline: '#ffffff'
      },
      {
        id: 'ral7011',
        name: 'COLORS.RAL7011',
        code: 'RAL 7011',
        color: '#244447',
        colorOutline: '#ffffff'
      },
      {
        id: 'ral9007',
        name: 'COLORS.RAL9007',
        code: 'RAL 9007',
        color: '#958f8c',
        colorOutline: '#000000'
      },
      {
        id: 'ral9006',
        name: 'COLORS.RAL9006',
        code: 'RAL 9006',
        color: '#b0bbc3',
        colorOutline: '#000000'
      },
      {
        id: 'ral9010',
        name: 'COLORS.RAL9010',
        code: 'RAL 9010',
        color: '#fefdf2',
        colorOutline: '#000000'
      },
      {
        id: 'ral9016',
        name: 'COLORS.RAL9016',
        code: 'RAL 9016',
        color: '#f2f8fb',
        colorOutline: '#000000'
      },
      {
        id: 'ral6009',
        name: 'COLORS.RAL6009',
        code: 'RAL 6009',
        color: '#00381e',
        colorOutline: '#ffffff'
      },
      {
        id: 'ral6005',
        name: 'COLORS.RAL6005',
        code: 'RAL 6005',
        color: '#00543b',
        colorOutline: '#ffffff'
      },
      {
        id: 'ral5003',
        name: 'COLORS.RAL5003',
        code: 'RAL 5003',
        color: '#001e42',
        colorOutline: '#ffffff'
      },
      {
        id: 'ral3005',
        name: 'COLORS.RAL3005',
        code: 'RAL 3005',
        color: '#9a0f28',
        colorOutline: '#ffffff'
      },
      {
        id: 'ral3003',
        name: 'COLORS.RAL3003',
        code: 'RAL 3003',
        color: '#b50d21',
        colorOutline: '#ffffff'
      },
      {
        id: 'db703',
        name: 'COLORS.DB703',
        code: 'DB703',
        color: '#554e4a',
        colorOutline: '#ffffff'
      },
      {
        id: 'db702',
        name: 'COLORS.DB702',
        code: 'DB702',
        color: '#716763',
        colorOutline: '#000000'
      },
      {
        id: 'db701',
        name: 'COLORS.DB701',
        code: 'DB701',
        color: '#8f8885',
        colorOutline: '#000000'
      }
    ],
    outsideColorSelectOptions: [
      {
        id: 'liverpool',
        name: 'COLORS.LIVERPOOL',
        code: '',
        color: '#b2967f',
        colorOutline: '#000000',
        outsideOnly: true,
        surcharge: true,
      },
      {
        id: 'sanssouci',
        name: 'COLORS.SANSSOUCI',
        code: '',
        color: '#c6baa6',
        colorOutline: '#000000',
        outsideOnly: true,
        surcharge: true,
      },
      {
        id: 'versaille',
        name: 'COLORS.VERSAILLE',
        code: '',
        color: '#c8c0bc',
        colorOutline: '#000000',
        outsideOnly: true,
        surcharge: true,
      },
      {
        id: 'blackmatt',
        name: 'COLORS.BLACKMATT',
        code: '',
        color: '#1f1f1f',
        colorOutline: '#ffffff',
        outsideOnly: true,
      },
    ],
    woodColorSelectOptions: [
      {
        id: 'woodredwood',
        name: 'COLORS.WOOD_REDWOOD',
        code: '',
        color: '#7f4e25',
        colorOutline: '#000000',
        wood: true,
      },
      {
        id: 'woodcanadianbrown',
        name: 'COLORS.WOOD_CANADIANBROWN',
        code: '',
        color: '#a46f47',
        colorOutline: '#000000',
        wood: true,
      },
      {
        id: 'woodcoolscandinavian',
        name: 'COLORS.WOOD_COOLSCANDINAVIAN',
        code: '',
        color: '#eebf89',
        colorOutline: '#000000',
        wood: true,
      },
      {
        id: 'woodteneriffagrey',
        name: 'COLORS.WOOD_TENERIFFAGREY',
        code: '',
        color: '#4d4a45',
        colorOutline: '#ffffff',
        wood: true,
      },
      {
        id: 'woodrockymountaingrey',
        name: 'COLORS.WOOD_ROCKYMOUNTAINGREY',
        code: '',
        color: '#7d7c7a',
        colorOutline: '#000000',
        wood: true,
      },
      {
        id: 'woodhimalayagrey',
        name: 'COLORS.WOOD_HIMALAYAGREY',
        code: '',
        color: '#a09593',
        colorOutline: '#000000',
        wood: true,
      },
    ],

    anchorOptions: [
      { sxno: 'SX 97-051-0',
        length: 1600,
        // TODO grafik
      },
      { sxno: 'SX 97-055-0',
        length: 1800,
        // TODO grafik
      },
      { sxno: 'SX 97-056-0',
        length: 2000,
        // TODO grafik
      }
    ],

    // list of all avaible luminaire configurations with sxnumbers and price
    // entries have to be in accordance to OLIVIO.-constants
    articleList: [
      {
        "lum": "grande",
        "distribution": "asymetric",
        "assembly": "hit",
        "power": "35w",
        "color": "",
        "sxno": "SX 386 41-9",
      },
      {
        "lum": "grande",
        "distribution": "asymetric",
        "assembly": "hit",
        "power": "70w",
        "color": "",
        "sxno": "SX 386 42-9",
      },
      {
        "lum": "grande",
        "distribution": "asymetric",
        "assembly": "hit",
        "power": "100w",
        "color": "",
        "sxno": "SX 386 43-9",
      },
      {
        "lum": "grande",
        "distribution": "asymetric",
        "assembly": "hit",
        "power": "150w",
        "color": "",
        "sxno": "SX 386 44-9",
      },
      {
        "lum": "grande",
        "distribution": "spot",
        "assembly": "hit",
        "power": "35w",
        "color": "",
        "sxno": "SX 386 11-9",
      },
      {
        "lum": "grande",
        "distribution": "spot",
        "assembly": "hit",
        "power": "70w",
        "color": "",
        "sxno": "SX 386 12-9",
      },
      {
        "lum": "grande",
        "distribution": "spot",
        "assembly": "hit",
        "power": "100w",
        "color": "",
        "sxno": "SX 386 13-9",
      },
      {
        "lum": "grande",
        "distribution": "spot",
        "assembly": "hit",
        "power": "150w",
        "color": "",
        "sxno": "SX 386 14-9",
      },
      {
        "lum": "grande",
        "distribution": "spot",
        "assembly": "cpo",
        "power": "45w",
        "color": "",
        "sxno": "SX 386 15-9",
      },
      {
        "lum": "grande",
        "distribution": "spot",
        "assembly": "cpo",
        "power": "60w",
        "color": "",
        "sxno": "SX 386 16-9",
      },
      {
        "lum": "grande",
        "distribution": "medium",
        "assembly": "hit",
        "power": "35w",
        "color": "",
        "sxno": "SX 386 21-9",
      },
      {
        "lum": "grande",
        "distribution": "medium",
        "assembly": "hit",
        "power": "70w",
        "color": "",
        "sxno": "SX 386 22-9",
      },
      {
        "lum": "grande",
        "distribution": "medium",
        "assembly": "hit",
        "power": "100w",
        "color": "",
        "sxno": "SX 386 23-9",
      },
      {
        "lum": "grande",
        "distribution": "medium",
        "assembly": "hit",
        "power": "150w",
        "color": "",
        "sxno": "SX 386 24-9",
      },
      {
        "lum": "grande",
        "distribution": "medium",
        "assembly": "cpo",
        "power": "45w",
        "color": "",
        "sxno": "SX 386 25-9",
      },
      {
        "lum": "grande",
        "distribution": "medium",
        "assembly": "cpo",
        "power": "60w",
        "color": "",
        "sxno": "SX 386 26-9",
      },
      {
        "lum": "grande",
        "distribution": "flood",
        "assembly": "hit",
        "power": "35w",
        "color": "",
        "sxno": "SX 386 31-9",
      },
      {
        "lum": "grande",
        "distribution": "flood",
        "assembly": "hit",
        "power": "70w",
        "color": "",
        "sxno": "SX 386 32-9",
      },
      {
        "lum": "grande",
        "distribution": "flood",
        "assembly": "hit",
        "power": "100w",
        "color": "",
        "sxno": "SX 386 33-9",
      },
      {
        "lum": "grande",
        "distribution": "flood",
        "assembly": "hit",
        "power": "150w",
        "color": "",
        "sxno": "SX 386 34-9",
      },
      {
        "lum": "grande",
        "distribution": "flood",
        "assembly": "cpo",
        "power": "45w",
        "color": "",
        "sxno": "SX 386 35-9",
      },
      {
        "lum": "grande",
        "distribution": "flood",
        "assembly": "cpo",
        "power": "60w",
        "color": "",
        "sxno": "SX 386 36-9",
      },
      {
        "lum": "medio",
        "distribution": "spot",
        "assembly": "hit",
        "power": "20w",
        "color": "",
        "sxno": "SX 385 10-9",
      },
      {
        "lum": "medio",
        "distribution": "spot",
        "assembly": "hit",
        "power": "35w",
        "color": "",
        "sxno": "SX 385 11-9",
      },
      {
        "lum": "medio",
        "distribution": "spot",
        "assembly": "hit",
        "power": "70w",
        "color": "",
        "sxno": "SX 385 12-9",
      },
      {
        "lum": "medio",
        "distribution": "medium",
        "assembly": "hit",
        "power": "20w",
        "color": "",
        "sxno": "SX 385 20-9",
      },
      {
        "lum": "medio",
        "distribution": "medium",
        "assembly": "hit",
        "power": "35w",
        "color": "",
        "sxno": "SX 385 21-9",
      },
      {
        "lum": "medio",
        "distribution": "medium",
        "assembly": "hit",
        "power": "70w",
        "color": "",
        "sxno": "SX 385 22-9",
      },
      {
        "lum": "medio",
        "distribution": "flood",
        "assembly": "hit",
        "power": "35w",
        "color": "",
        "sxno": "SX 385 31-9",
      },
      {
        "lum": "medio",
        "distribution": "flood",
        "assembly": "hit",
        "power": "70w",
        "color": "",
        "sxno": "SX 385 32-9",
      },
      {
        "lum": "piccolo",
        "distribution": "spot",
        "assembly": "hit",
        "power": "20w",
        "color": "",
        "sxno": "SX 384 10-9",
      },
      {
        "lum": "piccolo",
        "distribution": "spot",
        "assembly": "hit",
        "power": "35w",
        "color": "",
        "sxno": "SX 384 11-9",
      },
      {
        "lum": "piccolo",
        "distribution": "medium",
        "assembly": "hit",
        "power": "20w",
        "color": "",
        "sxno": "SX 384 20-9",
      },
      {
        "lum": "piccolo",
        "distribution": "medium",
        "assembly": "hit",
        "power": "35w",
        "color": "",
        "sxno": "SX 384 21-9",
      },
      {
        "lum": "piccolo",
        "distribution": "flood",
        "assembly": "hit",
        "power": "20w",
        "color": "",
        "sxno": "SX 384 30-9",
      },
      {
        "lum": "piccolo",
        "distribution": "flood",
        "assembly": "hit",
        "power": "35w",
        "color": "",
        "sxno": "SX 384 31-9",
      },

      // LED 2700K 2022
      { sxno: 'SX 960 40-9', lum: 'grande', color: '2700K', assembly: 'led', distribution: 'spot', power: 'g27s'},
      { sxno: 'SX 960 41-9', lum: 'grande', color: '2700K', assembly: 'led', distribution: 'medium', power: 'g27m'},
      { sxno: 'SX 960 42-9', lum: 'grande', color: '2700K', assembly: 'led', distribution: 'flood', power: 'g27f'},
      { sxno: 'SX 960 43-9', lum: 'grande', color: '2700K', assembly: 'led', distribution: 'asymetric', power: 'g27a'},
      { sxno: 'SX 961 40-9', lum: 'medio', color: '2700K', assembly: 'led', distribution: 'spot', power: 'm27s'},
      { sxno: 'SX 961 41-9', lum: 'medio', color: '2700K', assembly: 'led', distribution: 'medium', power: 'm27m'},
      { sxno: 'SX 961 42-9', lum: 'medio', color: '2700K', assembly: 'led', distribution: 'flood', power: 'm27f'},
      { sxno: 'SX 961 43-9', lum: 'medio', color: '2700K', assembly: 'led', distribution: 'asymetric', power: 'm27a'},
      { sxno: 'SX 962 40-9', lum: 'piccolo', color: '2700K', assembly: 'led', distribution: 'spot', power: 'p27s'},
      { sxno: 'SX 962 41-9', lum: 'piccolo', color: '2700K', assembly: 'led', distribution: 'medium', power: 'p27m'},
      { sxno: 'SX 962 42-9', lum: 'piccolo', color: '2700K', assembly: 'led', distribution: 'flood', power: 'p27f'},
      { sxno: 'SX 962 43-9', lum: 'piccolo', color: '2700K', assembly: 'led', distribution: 'asymetric', power: 'p27a'},

      // LED 28.8.2018
      {lum: 'grande', color: '3000K', assembly: 'led', distribution: 'spot', power: 'gs37w', sxno: 'SX 960 10-9'},
      {lum: 'grande', color: '3000K', assembly: 'led', distribution: 'medium', power: 'gm39w', sxno: 'SX 960 11-9'},
      {lum: 'grande', color: '3000K', assembly: 'led', distribution: 'flood', power: 'gf41w', sxno: 'SX 960 12-9'},
      {lum: 'grande', color: '3000K', assembly: 'led', distribution: 'asymetric', power: 'ga39w', sxno: 'SX 960 13-9'},
      {lum: 'grande', color: '4000K', assembly: 'led', distribution: 'spot', power: 'gs37w', sxno: 'SX 960 20-9'},
      {lum: 'grande', color: '4000K', assembly: 'led', distribution: 'medium', power: 'gm39w', sxno: 'SX 960 21-9'},
      {lum: 'grande', color: '4000K', assembly: 'led', distribution: 'flood', power: 'gf41w', sxno: 'SX 960 22-9'},
      {lum: 'grande', color: '4000K', assembly: 'led', distribution: 'asymetric', power: 'ga39w', sxno: 'SX 960 23-9'},
      {lum: 'medio', color: '3000K', assembly: 'led', distribution: 'spot', power: 'ms26w', sxno: 'SX 961 10-9'},
      {lum: 'medio', color: '3000K', assembly: 'led', distribution: 'medium', power: 'mm28w', sxno: 'SX 961 11-9'},
      {lum: 'medio', color: '3000K', assembly: 'led', distribution: 'flood', power: 'mf28w', sxno: 'SX 961 12-9'},
      {lum: 'medio', color: '3000K', assembly: 'led', distribution: 'asymetric', power: 'ma28w', sxno: 'SX 961 13-9'},
      {lum: 'medio', color: '4000K', assembly: 'led', distribution: 'spot', power: 'ms26w', sxno: 'SX 961 20-9'},
      {lum: 'medio', color: '4000K', assembly: 'led', distribution: 'medium', power: 'mm28w', sxno: 'SX 961 21-9'},
      {lum: 'medio', color: '4000K', assembly: 'led', distribution: 'flood', power: 'mf28w', sxno: 'SX 961 22-9'},
      {lum: 'medio', color: '4000K', assembly: 'led', distribution: 'asymetric', power: 'ma28w', sxno: 'SX 961 23-9'},
      {lum: 'piccolo', color: '3000K', assembly: 'led', distribution: 'spot', power: 'ps21w', sxno: 'SX 962 10-9'},
      {lum: 'piccolo', color: '3000K', assembly: 'led', distribution: 'medium', power: 'pm21w', sxno: 'SX 962 11-9'},
      {lum: 'piccolo', color: '3000K', assembly: 'led', distribution: 'flood', power: 'pf21w', sxno: 'SX 962 12-9'},
      {lum: 'piccolo', color: '3000K', assembly: 'led', distribution: 'asymetric', power: 'pa21w', sxno: 'SX 962 13-9'},
      {lum: 'piccolo', color: '4000K', assembly: 'led', distribution: 'spot', power: 'ps21w', sxno: 'SX 962 20-9'},
      {lum: 'piccolo', color: '4000K', assembly: 'led', distribution: 'medium', power: 'pm21w', sxno: 'SX 962 21-9'},
      {lum: 'piccolo', color: '4000K', assembly: 'led', distribution: 'flood', power: 'pf21w', sxno: 'SX 962 22-9'},
      {lum: 'piccolo', color: '4000K', assembly: 'led', distribution: 'asymetric', power: 'pa21w', sxno: 'SX 962 23-9'},

      // // RGBW 22.2.2018 color: 'RGBW' TODO diesen Block Oliver zwecks Kontrolle vorlegen
      {lum: 'grande', color: 'rgbw', assembly: 'led', distribution: 'spot', power: 'rgbw45w', sxno: 'SX 960 30-9'},
      {lum: 'grande', color: 'rgbw', assembly: 'led', distribution: 'medium', power: 'rgbw45w', sxno: 'SX 960 31-9'},
      {lum: 'grande', color: 'rgbw', assembly: 'led', distribution: 'flood', power: 'rgbw45w', sxno: 'SX 960 32-9'},
      {lum: 'medio', color: 'rgbw', assembly: 'led', distribution: 'spot', power: 'rgbw35w', sxno: 'SX 961 30-9'},
      {lum: 'medio', color: 'rgbw', assembly: 'led', distribution: 'medium', power: 'rgbw35w', sxno: 'SX 961 31-9'},
      {lum: 'medio', color: 'rgbw', assembly: 'led', distribution: 'flood', power: 'rgbw35w', sxno: 'SX 961 32-9'},
      {lum: 'piccolo', color: 'rgbw', assembly: 'led', distribution: 'spot', power: 'rgbw24w', sxno: 'SX 962 30-9'},
      {lum: 'piccolo', color: 'rgbw', assembly: 'led', distribution: 'medium', power: 'rgbw24w', sxno: 'SX 962 31-9'},
      {lum: 'piccolo', color: 'rgbw', assembly: 'led', distribution: 'flood', power: 'rgbw24w', sxno: 'SX 962 32-9'},


    ],

    // weiterhin nötig, weil getAllSX() die Daten hier ausliest (historisches price-Feld wurde entfernt)
    chargingPriceList: [
      {sxno: 'SX 987 10-0'},
      {sxno: 'SX 987 11-0'},
      {sxno: 'SX 987 12-0'},
      {sxno: 'SX 987 20-0'},
      {sxno: 'SX 987 21-0'},
      {sxno: 'SX 987 22-0'},
      {sxno: 'SX 987 30-0'},
      {sxno: 'SX 987 31-0'},
      {sxno: 'SX 987 32-0'}
    ]
  };

  // Calculate SX Numbers -----------------------

  //get article sx number for luminaire article
  data.getSXNumberForArticle = function (m, index) {
    var article = data.getArticle(m, index);
    console.log('data.getSXNumberForArticle '+index, {article, m});
    return (article.length > 0) ? article[0].sxno : '';
  };

  data.getSXNumberForBracket = function (id) {
    return data.getBracketOption(id).sxno;
  };
  data.getSXNumberForPiccoloBracket = function (id) {
    return data.getBracketOption(id).sxnoPiccolo;
  };


  data.getSXNumberForMast = function (m) {
    var mastOption = data.getMastOption(m.product.id);
    var index = mastOption.mastSizesmm.indexOf(m.design.height);
    var product = m.product.id;
    var lumcount = m.design.lumcount;
    var mastColor = data.getColorSelectOption(m.design.colorIds.mast);
    // console.log('getSXNumberForMast', {mastOption, index, product, lumcount, mastColor, isWood: (index > -1 && mastColor.wood), wood: mastColor && mastColor.wood});

    if (index > -1) {
      if (product !== OLIVIO.PRODUCT_CANDELABRA) {
        if(mastColor.wood) { // implizit Floracion
          // Vorsicht Heurisitik, die nur einen Teil der möglichen Konfigurationen abbildet, aktuell immer 220mm Durchmesser
          // TODO User bezüglich dünnere Maste fragen und hier berücksichtigen, ebenso bei konisch/rund bei 7m Höhe
          console.log('getSXNumberForMast wood:', {height: (m.design.height >= 10000 ? '' : '0') + Math.ceil(m.design.height / 10000)});
          return 'SX 161 ' +
            (m.design.height >= 10000 ? '' : '0') + Math.ceil(m.design.height / 1000) +
            '-W-' +
            '2' + // TODO Durchmesser (0=140, 1=168, 2=220)
            (m.design.height <= 7000 ? 0 : 1) + // Form (0=zylindrisch, 1= konisch)
            lumcount +
            '1' + // Anzahl Türen
            (m.design.anchor ? '1' : '3'/*TODO: Grafik, 3 prüfen*/)  // Gründung 1=Flanschplatte oder intergriertes Erdstück (2) oder Flanschplatte FRA(3)
        } else {
          return 'SX ' + mastOption.mastSX[index];
        }
      } else {
        return 'SX ' + mastOption.mastSXCandelabra[lumcount - 1][index];
      }
    } else {
      return '';
    }
  };
  data.getAllWoodMastSX = function() {
    var allSX=[];
    // nicht alle Werte und Kombinationen erlaubt, aber so bekommen wir alles was da ist
    for(var h=2;h<=12;h++) {
      for(var d=0;d<=2;d++) {
        for(var z=0;z<=1;z++) {
          for(var l=0;l<=8;l++) {
            for(var a=1;a<=3;a++) {
              allSX.push(
                'SX 161 ' +
                (h >= 10 ? '' : '0') + h +
                '-W-' +
                d + z + l +
                '1' // Türen
                + a
              );
            }
          }
        }
      }
    }
    return allSX;
  }

  data.getSXNumberForChargings = function(m) {
    return 'SX 987 ' + m.charging.type + m.charging.power + '-0';
  };

  data.getAllChargingSX = function() {
    allSX = [];
    for (var t=1;t<=3;t++) {
      for(var p=0;p<=2;p++) {
        allSX.push(
          'SX 987 '+ t + p + '-0'
        );
      }
    }
    return allSX;
  }

  // Anchor
  data.getLengthForAnchor = function(m) {
    return m.design.anchor ?
      (m.design.height <= 8000 ? 1600 :
        (m.design.height >= 12000 ? 2000 : 1800 ))
      : NaN;
  };
  data.getSXNumberForAnchor = function(m) {
    if(m.design.product === OLIVIO.PRODUCT_CANDELABRA || !m.design.anchor)
      return null;

    var l = data.getLengthForAnchor(m);
    return data.anchorOptions.filter(function(anchor) { return anchor.length === l;})[0].sxno;
  };

  data.sx2dbSX = function(sx) {
    return (sx
      .replace(/-W-[0-9]*$/, '-W-9')  // Holzmasten TODO check, weil dadruch Form (konisch vs. zylindrisch), Anzahl der Türen usw. keine Auswirkung auf den Preis hat
      .replace(/^SX 161 (\d\d)-\d\d*$/, function(match, p) {return 'SX 161 '+p+'-9'}) // reguläre Masten
    );
  }

  if(typeof module !== 'undefined') {
    console.log('Data: module');
    var mapPrefixSX = function(v) {return 'SX '+v;};
    data.getAllSx=function() {
      var allSX=[
        data.goboHead.sxno
      ];

      for(var i=0;i<data.mastOptions.length;i++) {
        allSX = allSX.concat(data.mastOptions[i].mastSX.map(mapPrefixSX));
        if(data.mastOptions[i].mastSXCandelabra && data.mastOptions[i].mastSXCandelabra.length) {
          for(var j=0;j<data.mastOptions[i].mastSXCandelabra.length;j++) {
            allSX = allSX.concat(data.mastOptions[i].mastSXCandelabra[j].map(mapPrefixSX));
          }
        }
      }

      for(var i=0;i<data.bracketOptions.length;i++) {
        allSX.push(data.bracketOptions[i].sxno);
        if(data.bracketOptions[i].sxnoPiccolo) {
          allSX.push(data.bracketOptions[i].sxnoPiccolo);
        }
      }

      for(var i=0;i<data.goboOptions.length;i++) {
        allSX.push(data.goboOptions[i].sxno);
      }

      for(var i=0;i<data.anchorOptions.length;i++) {
        allSX.push(data.anchorOptions[i].sxno);
      }

      for(var i=0;i<data.articleList.length;i++) {
        allSX.push(data.articleList[i].sxno);
      }

      for(var i=0;i<data.chargingPriceList.length;i++) {
        allSX.push(data.chargingPriceList[i].sxno);
      }

      allSX = allSX.concat(data.getAllWoodMastSX());
      allSX = allSX.concat(data.getAllChargingSX());

      return allSX;
    };

    module.exports = data;
  } else {
    angular.module('olivioConfiguratorApp').factory('Data', function ($rootScope, $translate, DescData, env) {
      data.chargingPowerOptions = [
        // according to definition in slxstele/config.js
        //  // enspricht derzeit 2017-04 den SX-Nummernkürzel
        //  export const C_POWER_3k7 = '0';
        //  export const C_POWER_11k = '1';
        //  export const C_POWER_22k = '2';
        {
          id: '0',
          name:'3' + $translate('MATH.FRACTION') + '7kW'
        },
        {
          id: '1',
          name: '11kW'
        },
        {
          id: '2',
          name: '22kW'
        }
      ];
      data.chargingTypeOptions = [
        // according to definition in slxstele/config.js
        //  // enspricht derzeit 2017-04 den SX-Nummernkürzel
        //  export const C_TYPE_BASIC = '1';
        //  export const C_TYPE_ADV = '2';
        //  export const C_TYPE_PROF = '3';
        {
          id: '1',
          name:'CHARGING.CHARGING_BASIC'
        },
        {
          id: '2',
          name: 'CHARGING.CHARGING_ADV'
        },
        {
          id: '3',
          name: 'CHARGING.CHARGING_PROF'
        }
      ];
      data.chargingArrangementOptions = [
        // 0
        [
          [false, false, false]
        ],
        // 1
        [
          [false, true, false],
          [true, false, false],
          [false, false, true]
        ],
        // 2
        [
          [true, true, false],
          [true, false, true],
          [false, true, true]
        ],
        // 3
        [
          [true, true, true]
        ]
      ];

      data.getProductOption = function (id) {
        return getOption(data.productOptions, id);
      };
      data.getLumOption = function (id) {
        return getOption(data.lumOptions, id);
      };
      data.getBracketOption = function (id) {
        return getOption(data.bracketOptions, id);
      };
      data.getMastOption = function (id) {
        return getOption(data.mastOptions, id);
      };
      data.getMastOptionsForProduct = function (id) {
        var retOptions = [];
        for (var i = 0; i < data.mastOptions.length; i++) {
          if (data.mastOptions[i].productid === id) {
            retOptions.push(data.mastOptions[i]);
          }
        }
        return retOptions;
      };
      data.getAssemblyOption = function (id) {
        return getOption(data.assemblyOptions, id);
      };
      data.getDistributionOption = function (id) {
        return getOption(data.distributionOptions, id);
      };
      data.getGoboOption = function (id) {
        return getOption(data.goboOptions, id);
      };
      data.getColorOption = function (id) {
        return getOption(data.colorOptions, id);
      };
      data.getPowerOption = function (id) {
        return getOption(data.powerOptions, id);
      };
      data.getColorSelectOption = function (id) {
        return getOption(data.colorSelectOptions, id);
      };
      data.getChargingPowerOption = function(id) {
        return getOption(data.chargingPowerOptions, id);
      };
      data.getChargingTypeOption = function(id) {
        return getOption(data.chargingTypeOptions, id);
      };
      data.getChargingArrangementOption = function(count, index) {
        //console.log('getChargingArrangementOption', count, index, (!(count >= 0 || count <=3)), data.chargingArrangementOptions[count][index]);
        if(!(count >= 0 || count <=3))
          return data.chargingArrangementOptions[0][0]; // f f f

        if(!data.chargingArrangementOptions[count][index])
          return data.chargingArrangementOptions[count][0];
        else
          return data.chargingArrangementOptions[count][index];
      };


      data.getArticle = function getArticle(m, index) {
        if(m.gobo.individual[index])
          return [data.getGoboOption(m.gobo.individualType[index])];

        var lum = (m.design.individualHeads[index] !== undefined) ? m.design.individualHeads[index] : "";
        var assembly = (m.assembly.individual[index] !== undefined) ? m.assembly.individual[index] :
          m.assembly.id ? m.assembly.id : "led";
        var power = (m.power.individual[index] !== undefined) ? m.power.individual[index] : "";
        var distribution = (m.distribution.individual[index] !== undefined) ? m.distribution.individual[index] : "";
        var color = (m.color.individual[index] !== undefined) ? m.color.individual[index] : "";

        console.log('data.getArticle', {lum, assembly, power, distribution, color });

        return data.articleList.filter(function (article) {
          return article.lum === lum && article.assembly === assembly && article.power === power && article.distribution === distribution && article.color === color;
        });

      }


      data.getMountingManualFile = function (m) {
        var file = "";

        if (m.assembly.id !== 'led') { // FIXME testen/Oliver fragen ob die Zip richtig ist
          if (m.design.beamtype === OLIVIO.BRACKET_SISTEMA1 || m.design.beamtype === OLIVIO.BRACKET_SISTEMA2) {
            file = "files/mounting/sistema1_2.zip";
          } else {
            file = "files/mounting/sistema3.zip";
          }
        } else {
          if (m.design.beamtype === OLIVIO.BRACKET_SISTEMA1 || m.design.beamtype === OLIVIO.BRACKET_SISTEMA2) {
            file = "files/mounting/sistema1_2-LED.zip";
          } else {
            file = "files/mounting/sistema3-LED.zip";
          }
        }

        return file;
      };


      // calculate prices
      data.getPriceForAnchor = function(m) {
        if(m.design.product === OLIVIO.PRODUCT_CANDELABRA || !m.design.anchor)
          return 0;

        var sx=data.sx2dbSX(data.getSXNumberForAnchor(m));
        return DescData[sx] ? DescData[sx].price : NaN;
      };

      // Calculate prices -----------------------

      //get the price for luminaire article
      data.getPriceForGoboHead = function(m, index) {
        if(!m.gobo.individual[index])
          return 0;

        // Gobo hat zwei Teile, das hier ist der Kopf ohne Objektiv, jenes läuft über die allgemeine Funktion für Article
        return DescData[data.goboHead.sxno] ? DescData[data.goboHead.sxno].price : NaN;
      };

      data.getPriceForArticle = function (m, index) {
        var sx = data.getSXNumberForArticle(m, index);
        return DescData[sx] ? DescData[sx].price : NaN;
      };

      data.getPriceForMast = function (m) {
        // FIXME Aufpreis OutsideColor → direkt in checkout.html
        var sx=data.sx2dbSX(data.getSXNumberForMast(m));
        return DescData[sx] ? DescData[sx].price : NaN;
      };

      data.getPriceForBrackets = function (m, lumcount) {
        var product = m.product.id;
        if(product !== OLIVIO.PRODUCT_SISTEMA)
          return 0;

        if (!lumcount)
          return 0;

        var sx = data.getSXNumberForBracket(m.design.beamtype);
        return (lumcount * (DescData[sx] ? DescData[sx].price : NaN));
      };

      data.getPriceForPiccoloBrackets = function (m, lumcount) {
        var product = m.product.id;
        if(product !== OLIVIO.PRODUCT_SISTEMA)
          return 0;

        if (!lumcount)
          return 0;

        var sx = data.getSXNumberForPiccoloBracket(m.design.beamtype);
        return (lumcount * (DescData[sx] ? DescData[sx].price : NaN));
      };

      data.getPriceForChargings = function(m){
        if (!(m.charging.count > 0))
          return 0;

        var sx = data.getSXNumberForChargings(m);
        return (m.charging.count * (DescData[sx] ? DescData[sx].price : NaN));
      };

      data.getPriceSurchargeMastColor = function(m, lumcountNonPiccolo, lumcountPiccolo) {
        var filtered = data.colorSelectOptions.filter(function(c) {return c.id === m.design.colorIds.mast});
        if(filtered[0] && filtered[0].surcharge) {
          return 555.56 + (Math.round(5 * data.getPriceSumInternal(m, lumcountNonPiccolo, lumcountPiccolo))/100); // 555.56 + 5% auf Cent genau
        } else {
          return 0;
        }
      }

      data.getPriceSurchargeLumColor = function(m, lumcountNonPiccolo, lumcountPiccolo) {
        var filtered = data.colorSelectOptions.filter(function(c) {return c.id === m.design.colorIds.lumiere});

        if(m.product.id === OLIVIO.PRODUCT_FLORACION && m.design.colorIds.lumiere !== m.design.colorIds.mast &&
          filtered[0] && filtered[0].surcharge) {
          return 555.56 + (Math.round(5 * data.getPriceSumInternal(m, lumcountNonPiccolo, lumcountPiccolo))/100); // 555.56 + 5% auf Cent genau
        } else {
          return 0;
        }
      }

      data.getPriceSum = function(m, lumcountNonPiccolo, lumcountPiccolo) {
        return (
          data.getPriceSumInternal(m, lumcountNonPiccolo, lumcountPiccolo)
          + data.getPriceSurchargeMastColor(m, lumcountNonPiccolo, lumcountPiccolo)
          + data.getPriceSurchargeLumColor(m, lumcountNonPiccolo, lumcountPiccolo)
        );
      }

      data.getPriceSumInternal = function (m, lumcountNonPiccolo, lumcountPiccolo) {
        var sumPrice = 0;
        for (var i = 0; i < m.design.lumcount; i++) {
          sumPrice += data.getPriceForArticle(m, i) + data.getPriceForGoboHead(m, i);
        }
        sumPrice += (data.getPriceForMast(m) + data.getPriceForBrackets(m, lumcountNonPiccolo) + data.getPriceForPiccoloBrackets(m, lumcountPiccolo) + data.getPriceForChargings(m) + data.getPriceForAnchor(m) ); //

        if(sumPrice && !isNaN(sumPrice)) {
          return sumPrice;
        } else {
          console.warn('getSumPrice invalid result ' + sumPrice,
            {
              mast: data.getPriceForMast(m),
              brackets: data.getPriceForBrackets(m, lumcountNonPiccolo),
              piccoloBrackets: data.getPriceForPiccoloBrackets(m, lumcountPiccolo),
              chargings: data.getPriceForChargings(m),
              anchor: data.getPriceForAnchor(m),
              // TODO aufpreis farbe
            }
          );
          return NaN;
        }
      };


      // --------------------

      data.checkModelState = function (m) {
        return true; // FIXME checkModelState
        /*
         data.checkProductOption(m.product.id) &&
         data.checkDesignOptions(m.product.id, m.design.height, m.design.lumcount, m.design.lumtype, m.design.beamtype) &&
         data.checkAssemblyOptions(m.product.id, m.design.lumtype, m.assembly.id) &&
         data.checkDistributionOptions(m.product.id, m.design.lumtype, m.assembly.id, m.distribution.id) &&
         data.checkColorOption(m.product.id, m.design.lumtype, m.assembly.id, m.distribution.id, m.color.id) &&
         data.checkPowerOption(m.product.id, m.design.lumtype, m.assembly.id, m.distribution.id, m.color.id, m.power.id) &&
         */
      };

      data.checkProductOption = function (productId) {
        return (productId === '' || data.getProductOption(productId) !== undefined);
      };

      // TODO topToBottomRotation startDegree topToBottomRotationCW toplumiereheight bottomlumiereheight individualHeights individualRotations colorIds colors
      data.checkDesignOptions = function (productId, height, lumcount, lumtype, beamtype) {
        // TODO check for dependencies fom productId to lumtype and beamtype
        if (lumcount < 1 || lumcount > 8 || height < 2000 || height > 12000) {
          return false;
        }
        if (lumtype !== '' && !data.getLumOption(lumtype)) {
          return false;
        }
        if (beamtype !== '' && !data.getBracketOption(beamtype)) {
          return false;
        }
        if (lumtype === OLIVIO.LUM_PICCOLO && (
          (productId === OLIVIO.PRODUCT_CANDELABRA || productId === OLIVIO.PRODUCT_FLORACION) ||
          (beamtype === OLIVIO.BRACKET_SISTEMA1 || beamtype == OLIVIO.BRACKET_SISTEMA2)
        )) {
          return false;
        }


        return true;
      };

      data.checkAssemblyOptions = function (productId, lumtype, assemblyId) {
        return (assemblyId === '' || data.getAssemblyOption(assemblyId) && !(assemblyId === 'cpo' && lumtype === OLIVIO.LUM_MEDIO));
      };

      data.checkDistributionOptions = function (productId, lumtype, assemblyId, distributionId, colorId) {
        // TODO individual müsste getestet werden
        return (distributionId === '' || data.getDistributionOption(distributionId) && !(distributionId === 'asymetric' && (assemblyId === 'cpo' || colorId === 'rgbw') ));
      };

      data.checkColorOption = function (productId, lumtype, assemblyId, distributionId, colorId) {
        // ja, gültig wenn *nicht* led oder gültige farbe
        // TODO eigentlich Schleife über individual nötig
        console.warn('checkColorOption',assemblyId, distributionId, 'colorId: '+colorId, data.getColorOption(colorId),
          'tests:',
          (colorId === '' || assemblyId !== 'led' || data.getColorOption(colorId)),
          !(colorId === 'rgbw' && distributionId === 'asymetric'),
          '&& :' + ((colorId === '' || assemblyId !== 'led' || data.getColorOption(colorId)) &&
            !(colorId === 'rgbw' && distributionId === 'asymetric')
          )
        );

        return (colorId === '' || assemblyId !== 'led' || data.getColorOption(colorId)) &&
          !(colorId === 'rgbw' && distributionId === 'asymetric') ;
      };

      data.checkPowerOption = function (productId, lumtype, assemblyId, distributionId, colorId, powerId) {
        // TODO: implement checkPowerOption (Schleife über individual nötig)
        // according to power.js  Data.getPowerOption(x).disabled = ...
        // dh. es ist valid, wenn nicht eine option gewählt ist, die disabled ist
        return true;
      };

      data.checkChargingOptions = function(count, chargingType, chargingPower) {
        // FIXME positions

        if(!(count>=0 && count<= 3))
          return false;

        switch(chargingType) {
          case '1':
          case '2':
          case '3':
            break;
          default:
            return false;
        }

        switch(chargingPower) {
          case '0':
          case '1':
          case '2':
            break;
          default:
            return false;
        }

        return true;
      };

      data.checkGobo = function(gobo, design) {
        design.gobo = false; // never start with Gobo-list after loading
        if(gobo === undefined || gobo === null ||
          (gobo.done && !data.getGoboOption(gobo.id))
        ) {
          return false;
        } else {
          for(var i=0; i<design.lumcount; i++) {
            if(gobo.individual[i] && (!gobo.individualType[i] || !data.getGoboOption(gobo.individualType[i]))) {
              return false;
            }
          }
        }
        return true;
      };


      data.applyConstraints = function (m) {
        data.applyColorConstraints(m);
        data.applyDistributionConstraints(m);
        data.applyPowerConstraints(m);
        data.applyLumConstraints(m);
      };

      data.applyDistributionConstraints = function (m) {

        for (var i = 0; i < data.distributionOptions.length; i++) {
          var option = data.distributionOptions[i];
          data.getDistributionOption(option.id).disabled = findAvaibleOptions("distribution", m.design.lumtype, null, m.assembly.id, m.color.id, null).indexOf(option.id) === -1;
        }

      };

      data.applyColorConstraints = function (m) {

        for (var i = 0; i < data.colorOptions.length; i++) {
          var option = data.colorOptions[i];
          data.getColorOption(option.id).disabled = findAvaibleOptions("color", m.design.lumtype, null, m.assembly.id, null, null).indexOf(option.id) === -1;
        }
        console.log('after applyColorConstraints', data.colorOptions.filter(o => !o.disabled));
      };

      data.applyPowerConstraints = function (m) {
        var avaibleOptions = findAvaibleOptions("power", m.design.lumtype, m.distribution.id, m.assembly.id, m.color.id, null);
        for (var i = 0; i < data.powerOptions.length; i++) {
          // var option = data.powerOptions[i];
          // data.getPowerOption(option.id).disabled = avaibleOptions.indexOf(option.id) === -1;
          data.powerOptions[i].disabled = avaibleOptions.indexOf(data.powerOptions[i].id) === -1;
        }
        // console.log('-> applayPowerContraints: data.powerOptions:',data.powerOptions);
      };

      data.findIndividualDistributionOptions = function (m, i) {
        var lumType = m.design.individualHeads[i];
        var color = m.color.individual[i];
        var assembly = m.assembly.individual[i];
        return findAvaibleOptions("distribution", lumType, null, assembly, color, null);
      };

      data.findIndividualPowerOptions = function (m, i) {
        var lumType = m.design.individualHeads[i];
        var color = m.color.individual[i];
        var distribution = m.distribution.individual[i];
        var assembly = m.assembly.individual[i];
        return findAvaibleOptions("power", lumType, distribution, assembly, color, null);
      };

      data.getLumOptionsForProduct = function(productId) {
        var filterIds = [OLIVIO.LUM_GRANDE, OLIVIO.LUM_MEDIO];
        if(productId === OLIVIO.PRODUCT_SISTEMA) {
          filterIds.push(OLIVIO.LUM_PICCOLO);
        }
        return filterOptionsByFilterId(data.lumOptions, filterIds);
      };

      data.applyLumConstraints = function (m) {
        data.getLumOption(OLIVIO.LUM_PICCOLO).disabled = (m.product.id === OLIVIO.PRODUCT_CANDELABRA || m.product.id === OLIVIO.PRODUCT_FLORACION || data.isLumAllowedForBracket(data.getBracketOption(m.design.beamtype), OLIVIO.LUM_PICCOLO) === false);
        data.getLumOption(OLIVIO.LUM_MEDIO).disabled = (m.assembly.id === 'cpo');
        data.getLumOption(OLIVIO.LUM_GRANDE).disabled = false;
      };

      data.isLumAllowedForBracket = function (bracketOption, lumId) {
        return (bracketOption.attachablelums.indexOf(lumId) > -1);
      };

      function findAvaibleOptions(option, lum, distribution, assembly, color, power) {
        // filter articles with matching options
        var filterData = data.articleList.filter(function (article) {
          var passFilter = true;

          if (lum) {
            passFilter = passFilter && (article.lum === lum);
          }
          if (assembly) {
            passFilter = passFilter && (article.assembly === assembly);
          }
          if (distribution) {
            passFilter = passFilter && (article.distribution === distribution);
          }
          if (color) {
            passFilter = passFilter && (article.color === color);
          }
          if (power) {
            passFilter = passFilter && (article.power === power);
          }

          return passFilter;
        });

        var avaibleOptions = [];
        for (var i = 0; i < filterData.length; i++) {
          var avaibleOption = filterData[i][option];
          if (avaibleOption !== undefined && avaibleOptions.indexOf(avaibleOption) === -1) {
            avaibleOptions.push(avaibleOption);
          }
        }
        // console.log('findAvaibleOptions(', option, lum, distribution, assembly, color, power,')', filterData, avaibleOptions);
        return avaibleOptions;
      }


      function filterOptionsByFilterId(options, allowedFilterIds) {
        var newOptions = [];
        //console.log(options);
        for (var i = 0; i < options.length; i++) {
          //console.log("filterid", options[i]);
          if (allowedFilterIds.indexOf(options[i].filterid) > -1) {
            newOptions.push(options[i]);
          }
        }
        return newOptions;
      }

      data.productOptions = filterOptionsByFilterId(data.productOptions, [OLIVIO.PRODUCT_SISTEMA, OLIVIO.PRODUCT_FLORACION, OLIVIO.PRODUCT_CANDELABRA]);
      data.mastOptions = filterOptionsByFilterId(data.mastOptions, ['sistema_international', 'floracion_international', 'candelabra_international']);
      data.bracketOptions = filterOptionsByFilterId(data.bracketOptions, ['sistema1_international', 'sistema2_international', 'sistema3_international']);
      // data.lumOptions = filterOptionsByFilterId(data.lumOptions, [OLIVIO.LUM_PICCOLO, OLIVIO.LUM_MEDIO, OLIVIO.LUM_GRANDE]); // this is a NOP
      data.assemblyOptions = filterOptionsByFilterId(data.assemblyOptions, ['led', 'hit', 'cpo']);
      data.distributionOptions = filterOptionsByFilterId(data.distributionOptions, ['asymetric', 'spot', 'medium', 'flood']);
      data.colorOptions = filterOptionsByFilterId(data.colorOptions, ['2700K', '3000K', '4000K', 'rgbw']);
      //data.powerOptions = filterOptionsByFilterId(data.powerOptions, ['20w', '24w', '26w', '29w', '35w', '37w', '39w', '41w', '45w', '49w', '53w', '60w', '70w', '100w', '150w']);

      function getOption(options, id) {
        // TODO add support for ES6 to project
        //return Array.find(o => o.id === id) || false;
        for (var i = 0; i < options.length; i++) {
          if (options[i].id === id) {
            return options[i];
          }
        }
        return false;
      }

      data.colorSelectOptions = data.metalColorSelectOptions.concat(data.outsideColorSelectOptions).concat(data.woodColorSelectOptions);

      return data;

    });
  }

})();
